<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
body{
  margin:0px;
  padding:0px;
  letter-spacing:2px;

  font-family:PingFangSC-Regular,Helvetica Neue,Hiragino Sansgb,Arial,Microsoft Yahei,Microsoft Yahei ui,Simsun,Sans-serif;

}

#app{
  margin:0 auto;
}
</style>
